import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { AlertController, LoadingController, ModalController, Platform } from '@ionic/angular';
import {
  addDays,
  addHours,
  eachDayOfInterval,
  format,
  intervalToDuration,
  isSaturday,
  isSunday,
  isValid
} from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { DevUtils } from 'src/providers/apiservices/Utils';
import { APIService } from 'src/providers/apiservices/apiservices';
import { Events } from 'src/providers/apiservices/eventsservice';
import {
  GlobalService,
  ToastColors,
} from 'src/providers/apiservices/globalservices';
import { LocalStorageProvider } from 'src/providers/apiservices/localstorageprovider';
import { AutorizacaoServicoProvider } from 'src/providers/autorizacaoservico/autorizacaoservico';
import { ComunicacaoProvider } from 'src/providers/comunicacao/comunicacao';
import { ContratoProvider } from 'src/providers/contrato/contrato';
import { EmpresaProvider } from 'src/providers/empresa/empresa';
import { ServicosProvider } from 'src/providers/servicos/servicos';
import { UserConfigDto } from 'src/providersdata/UserConfigDto';
import { read as xlsxRead, utils as xlsxUtils } from 'xlsx';
import {
  SelectSearchableItem,
  SelectSearchablePage,
} from '../select-searchable/select-searchable.page';

@Component({
  selector: 'app-createautorizacaoservico',
  templateUrl: './createautorizacaoservico.page.html',
  styleUrls: ['./createautorizacaoservico.page.scss'],
})
export class CreateautorizacaoservicoPage implements OnInit {
  /**
   * YYYY-MM-DD
   */
  currentDate = new Date().toISOString();

  @ViewChild('InputFile') inputFile: ElementRef<HTMLInputElement>;
  @ViewChild('InputFileModelo') inputFileModelo: ElementRef<HTMLInputElement>;

  @ViewChild('descricaoServicoElement') descricaoServicoElement: any;
  @ViewChild('dataInicioElement') dataInicioElement: any;
  @ViewChild('dataTerminoElement') dataTerminoElement: any;
  @ViewChild('telefoneContatoElement') telefoneContatoElement: any;

  @Input() isEdit: boolean = false;
  @Input() autorizacaoServicoId: string = '';
  @Input() taskId: string = '';
  @Input() autorizacaoServico: any = null;
  @Input() tarefa: any = null;

  bdServicoData: any = null;

  autorizacaoServicoResponse: any = null;

  configUser: UserConfigDto = new UserConfigDto(null);
  pickedDocuments: any[] = [];
  form_cadastro: FormGroup;
  malls: any[] = [];

  stores: any[] = [];
  selected_contratoTexto: string = '';

  servicos: any[] = [];

  idEmpresaSelecionada: string = '';

  servico_selecionado: string = '';
  get dataPossivelInicio() {
    if (!this.bdServicoData) return new Date();

    var dtDiaPossivel = new Date();

    const servico = this.bdServicoData;

    if (servico.qtdDiasAntesAbertura > 0) {
      dtDiaPossivel = addDays(dtDiaPossivel, servico.qtdDiasAntesAbertura);
    }

    if (new Date().getHours() >= 17) {
      dtDiaPossivel = addDays(dtDiaPossivel, 1);
    }

    while (isSaturday(dtDiaPossivel) || isSunday(dtDiaPossivel)) {
      if (this.bdServicoData.considerarFinaisSemana === true) {
        break;
      }

      dtDiaPossivel = addDays(dtDiaPossivel, 1);
    }

    // while(dtDiaPossivel < new Date())
    // {
    //   //console.log(new Date())
    //   //console.log("dia possivel menor que data/hora atual, add+1", dtDiaPossivel)
    //   dtDiaPossivel = addDays(dtDiaPossivel, 1);
    // }


    const [horaInicioServico, minutoInicioServico] = servico.horaInicio.split(':');
    const [horaTerminoServico, minutoTerminoServico] = servico.horaFim.split(':');

    const dtInicioServicoHoje = new Date()
    dtInicioServicoHoje.setHours(horaInicioServico, minutoInicioServico, 0, 0)
    const dtFimServicoHoje = new Date()
    dtFimServicoHoje.setHours(horaTerminoServico, minutoTerminoServico, 0, 0)



    let dtTerminoServico = new Date(dtDiaPossivel);
    dtTerminoServico.setHours(horaTerminoServico, minutoTerminoServico, 0, 0)

    //console.log(dtTerminoServico, "dtTerminoServico")
    //console.log(new Date(), 'new Date()')

    if(dtInicioServicoHoje > dtFimServicoHoje)
    {
      // PODE IR ATÉ O OUTRO DIA

    }
    else if(dtTerminoServico < new Date())
    {
      //console.log("add+1", dtDiaPossivel)
      dtDiaPossivel = addDays(dtDiaPossivel, 1);
    }
    
    return new Date(dtDiaPossivel.setHours(0, 0, 0, 0));
  }

  // Controles
  isModalTermosOpen: boolean = false;
  editPerson: boolean = false;
  addPerson: boolean = false;
  addVehicle: boolean = false;
  validation_messages = {
    shopping_selecionado: [
      { type: 'required', message: 'Shopping é obrigatório.' },
    ],
    loja_selecionada: [
      { type: 'required', message: 'Loja selecionada é obrigatório' },
    ],
    descricaoServico: [
      { type: 'required', message: 'Descrição do serviço é obrigatório.' },
    ],
    servico_selecionado: [
      { type: 'required', message: 'Serviço é obrigatório' },
    ],
    telefoneContato: [
      { type: 'required', message: 'Telefone de contato é obrigatório.' },
      { type: 'maxlength', message: 'Tamanho do número é inválido.' },
      { type: 'pattern', message: 'Por favor, digite um telefone válido.' },
    ],
    dataInicio: [
      { type: 'required', message: 'Data de início é obrigatório.' },
      {
        type: 'invalid',
        message: `Data de início inválida.`,
      },
      {
        type: 'max',
        message: 'Data de início deve ser menor ou igual a data de término.',
      },
      // {
      //   type: 'servicomax',
      //   message: 'Verifique se a data de início respeita a data máxima para o serviço.',
      // },
      {
        type: "min_servico",
        message: `A data de início deve ser maior ou igual a data de início permitida para o serviço.`,
      },
      {
        type: 'min',
        message: `A data de início está incorreta, por favor verifique a data e hora preenchidas.`,
      },
    ],
    dataTermino: [
      { type: 'required', message: 'Data de término é obrigatório.' },
      {
        type: 'min',
        message: `Data de término deve seguir as especificações acima de hora e duração máxima permitida de dias.`,
      },
      {
        type: 'max',
        message:
          'Verifique se a data de término respeita a data máxima para o serviço.',
      },
      {
        type: 'invalid',
        message: `Data de término inválida.`,
      },
    ],
    timeInicio: [
      {
        type: 'invalid',
        message: `Hora de início inválida.`,
      },
      {
        type: 'max_termino',
        message: `Hora de inicio deve ser menor que a hora de término selecionada.`,
      },
      {
        type: "min_inicio",
        message: `Hora de início deve ser maior que ou igual a hora de início permitida para o serviço.`,
      }
    ],
    timeTermino: [
      {
        type: 'invalid',
        message: `Hora de término inválida.`,
      },
      {
        type: 'max',
        message: `Hora de término deve ser menor que ou igual a hora de término permitida para o serviço.`,
      },
      {
        type: 'min_inicio',
        message: `Hora de término deve ser maior que a hora de início selecionada.`,
      }
    ],
    termos_de_uso: [
      { type: 'required', message: 'Termos de uso é obrigatório.' },
    ],
    colaboradores: {
      nome: [
        { type: 'required', message: 'Informe o nome do colaborador.' },
        { type: 'maxlength', message: 'O nome deve ser de no máximo 100 caracteres.' },
      ],
      cpf: [
        { type: 'format', message: 'CPF inválido.' },
        { type: 'duplicated', message: 'O CPF não pode repetir.' },
      ],
      empresa: [
        { type: 'required', message: 'Informe a empresa do colaborador.' },
        { type: 'maxlength', message: 'O nome da empresa deve ser de no máximo 100 caracteres.' },
      ]
    },
    veiculos: {
      placa: [
        { type: 'required', message: 'Informe a placa do veículo.' },
        { type: 'duplicated', message: 'A placa do veículo não pode repetir.' },
      ],
    },
  };

  // Dados Serviço
  tituloServico = '';
  observacaoServico = [];
  descricaoServico = '';

  colaboradoresDuplicados = [];
  veiculosDuplicados = [];

  acceptTermos: boolean = false;

  errorElements = {};

  isMobile: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private globalService: GlobalService,
    private formBuilder: FormBuilder,
    private empresaProvider: EmpresaProvider,
    private loadingController: LoadingController,
    private alertController: AlertController,
    private contratoProvider: ContratoProvider,
    private servicosProvider: ServicosProvider,
    private autorizacaoServicoProvider: AutorizacaoServicoProvider,
    private providerLocalStorage: LocalStorageProvider,
    private event: Events,
    private platform: Platform,
  ) {}

  ngOnInit() {
    if (this.platform.is('ios') || this.platform.is('android')) {
      this.isMobile = true;
    }

    const usuario = APIService.UsuarioLogado.Usuario;

    this.form_cadastro = this.formBuilder.group({
      shopping_selecionado: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
      loja_selecionada: usuario.idTipoUsuario == 1 ? new FormControl('') : new FormControl('', Validators.compose([Validators.required])),
      servico_selecionado: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
      descricaoServico: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
      observacaoParaOAprovador: new FormControl(''),
      telefoneContato: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(16),
          Validators.pattern('[- +()0-9]+'),
        ])
      ),
      dataInicio: new FormControl(
        '',
        Validators.compose([Validators.required, this.validaDataInicio()])
      ),
      timeInicio: new FormControl(
        '',
        Validators.compose([Validators.required, this.validaHoraInicio()])
      ),
      dataTermino: new FormControl(
        '',
        Validators.compose([Validators.required, this.validaDataTermino()])
      ),
      timeTermino: new FormControl(
        '',
        Validators.compose([Validators.required, this.validaHoraTermino()])
      ),
      termos_de_uso: new FormControl(
        false,
        Validators.compose([Validators.requiredTrue])
      ),
      colaboradores: new FormArray(
        [],
        Validators.compose([this.hasDuplicate('cpf', this.colaboradoresDuplicados)])
      ),
      veiculos: new FormArray(
        [],
        // Validators.compose([this.hasDuplicate('placa', this.veiculosDuplicados)])
      ),
    });
  }

  ngAfterViewInit() {
    const usuario = APIService.UsuarioLogado.Usuario;

    this.configUser = this.providerLocalStorage.loggedUser.Config;

    this.globalService.devlog(usuario);

    this.errorElements['descricaoServicoElement'] =
      this.descricaoServicoElement.el;
    this.errorElements['dataInicioElement'] = this.dataInicioElement.el;
    this.errorElements['dataTerminoElement'] = this.dataTerminoElement.el;
    this.errorElements['telefoneContatoElement'] =
      this.telefoneContatoElement.el;
    //this.errorElements['termos_de_usoElementElement'] = this.termos_de_usoElementElement.el;

    this.carregarTela();
  }

  get colaboradores(): FormArray {
    return this.form_cadastro.get('colaboradores') as FormArray;
  }

  get veiculos(): FormArray {
    return this.form_cadastro.get('veiculos') as FormArray;
  }

  async seekToErrorElement(formBuilder) {
    try {
      const formElements = DevUtils.getAllFormControls(formBuilder);

      for (const { element, control, field } of formElements) {
        if (control.invalid) {
          control.markAsTouched();
          control.updateValueAndValidity();
          element.scrollIntoView();
          break;
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  goToErrorField() {
    if (this.form_cadastro.status == 'INVALID') {
      try {
        const errorsControlsEntries = Object.entries(
          this.form_cadastro.controls
        );

        const orderedControlList = [];

        const errorElementsEntries = Object.entries(this.errorElements);

        errorElementsEntries.forEach(([k, v]) => {
          let _key = k.replace('Element', '');

          if (this.form_cadastro.controls[_key]) {
            orderedControlList.push({
              key: k,
              value: this.form_cadastro.controls[_key],
              status: this.form_cadastro.controls[_key]?.status,
              element: v,
            });
          }
        });

        for (const currentElement of orderedControlList) {
          const { key, value, status, element } = currentElement;

          if (status == 'INVALID') {
            element.scrollIntoView();
            continue;
          }
        }
      } catch (error) {
        //console.log(error);
      }
    }
    //console.log('[ERROS]', this.form_cadastro, this.form_cadastro.errors);
  }

  validaDataTermino(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      const servico = this.servicos.find(
        (servico) =>
          servico.idServico ==
          this.form_cadastro.get('servico_selecionado').value
      );

      if (!servico) return null;

      let _dtDataTermino = control.value;
      let _dtDataTerminoZero = new Date(_dtDataTermino + ' 00:00:00');

      if (
        DevUtils.DATE_YYYY_MM_DD_REGEX.test(control.value) === false ||
        !isValid(_dtDataTerminoZero)
      ) {
        return {
          invalid: true,
        };
      }

      let _dtDataInicio = this.form_cadastro.get('dataInicio').value;
      // if(control.value == _dtDataInicio)
      // {
      //   return {
      //     min_inicio: true,
      //   };
      // }

      let _dtDataInicioZero = new Date(_dtDataInicio + ' 00:00:00');

      if (
        DevUtils.DATE_YYYY_MM_DD_REGEX.test(_dtDataInicio) === false ||
        !isValid(_dtDataInicioZero)
      ) {
        return null;
      }

      const interval = intervalToDuration({
        start: _dtDataInicioZero,
        end: _dtDataTerminoZero,
      });

      if (
        servico.qtdDiasDuracaoMaxima > 0 &&
        interval.days > servico.qtdDiasDuracaoMaxima
      ) {
        return {
          min: true,
        };
      }

      this.form_cadastro.controls["timeInicio"].updateValueAndValidity();
      this.form_cadastro.controls["timeTermino"].updateValueAndValidity();

      return null;
    };
  }

  validaDataInicio = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      var inputDtInicio = control.value;
      let _dtInicio = new Date(inputDtInicio + ' 00:00:00');

      if (
        DevUtils.DATE_YYYY_MM_DD_REGEX.test(inputDtInicio) == false ||
        !isValid(_dtInicio)
      ) {
        return {
          invalid: true,
        };
      }
      
      let dtDiaPossivel =  new Date(this.dataPossivelInicio.setHours(0, 0, 0, 0));

      if(_dtInicio < dtDiaPossivel)
      {
        return {
          min_servico: true,
        };
      }

      return null;
    };
  };

  validaHoraInicio = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        if(!control.value)
          return {
          invalid: true,
        };

        const servico = this.servicos.find(
          (x) =>
            x.idServico == this.form_cadastro.get('servico_selecionado').value
        );

        if(!servico)
          return null;

          //console.log("🚀 ~ CreateautorizacaoservicoPage ~ return ~ servico", servico)


        if(this.form_cadastro.controls["dataInicio"].valid == false)
        {
           this.form_cadastro.controls["dataInicio"].updateValueAndValidity();
           return null;
        }

        const [horaInicioServico, minutoInicioServico] = servico.horaInicio.split(':');
        const [horaTerminoServico, minutoTerminoServico] = servico.horaFim.split(':');

        const horarioLimiteInicial = `${horaInicioServico}:${minutoInicioServico}:00`;
        const horarioLimiteFinal = `${horaTerminoServico}:${minutoTerminoServico}:00`;

        const dtDiaPossivel = this.dataPossivelInicio;

        dtDiaPossivel.setHours(parseInt(horaInicioServico), parseInt(minutoInicioServico), 0, 0)

        let dtMax = new Date(dtDiaPossivel);
        dtMax = addDays(dtMax, servico.qtdDiasDuracaoMaxima)
        dtMax.setHours(horaTerminoServico, minutoTerminoServico, 0, 0)

        const servico_datas = {
          dataInicio: dtDiaPossivel,
          dataTermino: dtMax,
        }

        //console.log("��� ~ CreateautorizacaoservicoPage ~ return ~ servico_datas:", servico_datas)

        if(this.form_cadastro.get('dataInicio').valid === false || this.form_cadastro.get('dataTermino').valid === false)
        {
          return null;
        }

        const inputDataFinal = this.form_cadastro.get('dataTermino').value;
        const inputDataInicio = this.form_cadastro.get('dataInicio').value;
        const inputHorarioTermino = this.form_cadastro.get('timeTermino').value;

        const selecionado = {
          dataInicio: new Date(`${inputDataInicio} ${control.value}`),
          dataTermino: new Date(`${inputDataFinal} ${inputHorarioTermino}`),
        }

        //console.log("��� ~ CreateautorizacaoservicoPage ~ return ~ selecionado:", selecionado)


        if(selecionado.dataInicio < servico_datas.dataInicio)
        {
          return {
            min_inicio: true
          }
        }

        if(this.form_cadastro.get('timeTermino').valid === false)
        {
          return null;
        }

        if(inputDataInicio == inputDataFinal)
        {
          if(selecionado.dataInicio >= selecionado.dataTermino)
          {
            return {
              max_termino: true
            }
          }
        }

        return null;
    };
  };

  eachHoursFrom = (date: Date, toHours = 0) => {
    const each = []

    if(toHours == 0)
        return [date]

    for(let x = 1; x <= toHours; x++){
        each.push(date)

        date = addHours(date, 1)
    }

    return each;
}
  validaHoraTermino = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        if(!control.value)
          return {
          invalid: true,
        };

        const servico = this.servicos.find(
          (x) =>
            x.idServico == this.form_cadastro.get('servico_selecionado').value
        );

        if(!servico)
          return null;

          //console.log("🚀 ~ CreateautorizacaoservicoPage ~ return ~ servico", servico)

        const [horaInicioServico, minutoInicioServico] = servico.horaInicio.split(':');
        const [horaTerminoServico, minutoTerminoServico] = servico.horaFim.split(':');

        const horarioLimiteInicial = `${horaInicioServico}:${minutoInicioServico}:00`;
        const horarioLimiteFinal = `${horaTerminoServico}:${minutoTerminoServico}:00`;

        const dtDiaPossivel = this.dataPossivelInicio;

        dtDiaPossivel.setHours(parseInt(horaInicioServico), parseInt(minutoInicioServico), 0, 0)

        let dtMax = new Date(dtDiaPossivel);
        dtMax.setHours(horaTerminoServico, minutoTerminoServico, 0, 0)
        dtMax = addDays(dtMax, servico.qtdDiasDuracaoMaxima)

        const servico_datas = {
          dataInicio: dtDiaPossivel,
          dataTermino: dtMax,
        }



        if(this.form_cadastro.get('dataInicio').valid === false || this.form_cadastro.get('dataTermino').valid === false)
        {
          return null;
        }

        const inputDataFinal = this.form_cadastro.get('dataTermino').value;
        const inputDataInicio = this.form_cadastro.get('dataInicio').value;
        const inputHorarioInicio = this.form_cadastro.get('timeInicio').value;
        //console.log(inputDataFinal, inputDataInicio)

        const selecionado = {
          dataInicio: new Date(`${inputDataInicio} ${inputHorarioInicio}`),
          dataTermino: new Date(`${inputDataFinal} ${control.value}`),
        }
        //console.log("��� ~ CreateautorizacaoservicoPage ~ return ~ servico_datas:", servico_datas)

        //console.log("��� ~ CreateautorizacaoservicoPage ~ return ~ selecionado:", selecionado)

        const [
          horaSelecionada,
          minutoSelecionado
        ]
        = [
          selecionado.dataTermino.getHours(),
          selecionado.dataTermino.getMinutes()
        ]

        const [
          horaInicioSelecionada,
          minutoInicioSelecionada
        ] =
        [
          selecionado.dataInicio.getHours(),
          selecionado.dataInicio.getMinutes()
        ]

        const [
          horaServico,
          minutoServico
        ] = [
          servico_datas.dataTermino.getHours(),
          servico_datas.dataTermino.getMinutes()
        ]

        const each = this.eachHoursFrom(dtDiaPossivel, horaServico)

        //console.log("��� ~ CreateautorizacaoservicoPage ~ return ~ each", each)

        //  if(each.length > 2)
        //  {
        //   const start = each[0]
        //   const last = each[each.length - 1]


        //  }


        // Validando contra o serviço.
        if(inputDataFinal != inputDataInicio)
        {
          if(horaSelecionada > horaServico)
          {
            //console.log(horaSelecionada, horaServico, "MAIOR_QUE_HORA_SERVICO")
            return {
              max: true
            }
          }
          else if(horaSelecionada == horaServico)
          {
            if(minutoSelecionado > minutoServico)
            {
              //console.log(minutoSelecionado, minutoServico, "HORA_IGUAL_MAIOR_QUE_MINUTO_SERVICO")
              return {
                max: true
              }
            }
          }
        }
        // else
        // {

        // }

        if(this.form_cadastro.controls['timeInicio'].valid === false)
          return;

        // Validando contra a hora de inicio selecionada
        if(horaInicioServico > horaTerminoServico)
        {
          if(inputDataFinal == inputDataInicio)
          {
            if(horaSelecionada <= horaInicioSelecionada)
            {
              if(horaSelecionada < horaInicioSelecionada)
              {
                //console.log(horaSelecionada, horaInicioSelecionada, "MENOR_QUE_HORA_INICIO_SELECIONADO")
                return {
                  min_inicio: true
                }
              }
              else if(horaSelecionada == horaInicioSelecionada)
              {
                if(minutoSelecionado <= minutoInicioSelecionada)
                {
                  //console.log(minutoSelecionado, minutoInicioSelecionada, "HORA_IGUAL_MENOR_QUE_MINUTO_INICIO_SELECIONADO")
                  return {
                    min_inicio: true
                  }
                }
              }
            }
          }
        }
        // if(horaSelecionada < horaInicioSelecionada)
        // {
        //   //console.log(horaSelecionada, horaInicioSelecionada, "MENOR_QUE_HORA_INICIO_SELECIONADO")
        //   return {
        //     min_inicio: true
        //   }
        // }
        // else if(horaSelecionada == horaInicioSelecionada)
        // {
        //   if(minutoSelecionado < minutoInicioSelecionada)
        //   {
        //     //console.log(minutoSelecionado, minutoInicioSelecionada, "HORA_IGUAL_MENOR_QUE_MINUTO_INICIO_SELECIONADO")
        //     return {
        //       min_inicio: true
        //     }
        //   }
        // }

        return null;
    };
  };

  async carregarTela(): Promise<void> {
    try {
      await this.carregarEmpresas();

      const loading = await this.loadingController.create({
        message: 'Aguarde...',
      });

      loading.present();

      if (this.isEdit) {
        await this.carregarAutorizacaoServicoById(this.autorizacaoServicoId);
      } else {
        if (this.malls.length > 0) {
          this.form_cadastro.controls['shopping_selecionado'].setValue(
            this.configUser.idEmpresa
          );
        }
      }

      loading.dismiss();
    } catch (error) {
      this.globalService.devlog(error);
    }
  }

  async carregaAutorizacaoServicoValues(autorizacaoServicoItem: any) {
    this.form_cadastro.patchValue({
      shopping_selecionado: autorizacaoServicoItem.idEmpresa,
      descricaoServico: autorizacaoServicoItem.descricao,
      observacaoParaOAprovador: autorizacaoServicoItem.observacaoParaAprovador,
      telefoneContato: autorizacaoServicoItem.telefoneContato,
      dataInicio: autorizacaoServicoItem.dataInicio.split('T')[0],
      dataTermino: autorizacaoServicoItem.dataFim.split('T')[0],
      timeInicio: autorizacaoServicoItem.horaInicio,
      timeTermino: autorizacaoServicoItem.horaFim,
      termos_de_uso: true,
    });

    this.globalService.devlog(this.form_cadastro.value);

    this.form_cadastro.markAllAsTouched();

    const _toFiles: File[] =
      autorizacaoServicoItem.autorizacaoServicoArquivos.map((item, index) => {
        return {
          isEditAutorizationFile: true,
          name: item.idArquivoNavigation?.nomeArquivo || `Arquivo ${index}`,
        };
      });

    this.pickedDocuments = _toFiles;

    autorizacaoServicoItem.autorizacaoServicoColaboradors?.forEach((item) => {
      this.addColaborador(item.nomeColaborador, item.cpfColaborador, item.nomeEmpresaColaborador, item.idAutorizacaoServico);
    });

    autorizacaoServicoItem.autorizacaoServicoCarros.forEach((item) => {
      this.addVeiculo(item.marca, item.modelo, item.cor, item.placa, item.idAutorizacaoServico);
    });
  }

  async carregarAutorizacaoServicoById(id: string) {
    this.autorizacaoServicoProvider
      .getById(id)
      .then((response: any) => {
        if (response.Item) {
          if (response.Item.status_ret == 'NOK') {
            this.dismiss();
            this.globalService.publishToast({
              Mensagem: 'Não foi possível carregar a autorização de serviço.',
              Severidade: 2,
              Posicao: 'top',
            });
            return;
          }
          this.globalService.devlog(response.Item);

          this.autorizacaoServicoResponse = response.Item;

          this.carregaAutorizacaoServicoValues(this.autorizacaoServicoResponse);
        } else {
          this.globalService.publishToast({
            Mensagem: response.erro,
            Severidade: 2,
            Posicao: 'top',
          });
          this.dismiss();
        }
      })
      .catch((error: any) => {
        this.dismiss();
        this.globalService.devlog(error);
      });
  }

  setOpenTermosModal(isOpen: boolean) {
    this.isModalTermosOpen = isOpen;
  }
  async openLojasModal() {
    let lista: Array<SelectSearchableItem> = [];
    let listaFiltro: Array<SelectSearchableItem> = [];

    let selected_contrato = this.form_cadastro.get('loja_selecionada').value;
    let selected_mall = this.form_cadastro.get('shopping_selecionado').value;

    this.stores.forEach((loja) => {
      let item: SelectSearchableItem = new SelectSearchableItem(
        loja.value,
        loja.title,
        loja.value
      );

      if (this.configUser.tipoUsuario == 1) {
        return lista.push(item);
      }

      if (loja.value == this.configUser.numContrato) {
        lista.push(item);
      }
    });

    if (selected_contrato != '') {
      let item: SelectSearchableItem = new SelectSearchableItem(
        selected_contrato,
        this.selected_contratoTexto,
        selected_contrato
      );
      listaFiltro.push(item);
    }

    const modal = await this.modalCtrl.create({
      component: SelectSearchablePage,
      componentProps: {
        titulo: 'Lojas de ' + selected_mall,
        filtro: '',
        lista: lista,
        maxsize: 1,
        selecionados: listaFiltro,
      },
      cssClass: 'modal-edicao',
      backdropDismiss: false,
    });

    modal.onDidDismiss().then((ret) => {
      if (ret.data && ret.data.salvar) {
        ////console.log('selecionados: ', ret.data.selecionados);
        this.selected_contratoTexto = '';

        let quantAMais = 0;

        if (ret.data.selecionados.length > 0) {
          for (let i = 0; i < ret.data.selecionados.length; i++) {
            let loja = {
              value: ret.data.selecionados[i].id,
              title: ret.data.selecionados[i].texto,
            };

            if (!this.selected_contratoTexto) {
              this.selected_contratoTexto = ret.data.selecionados[i].texto;
            } else {
              quantAMais++;
            }

            this.form_cadastro.controls['loja_selecionada'].setValue(
              loja.value
            );
          }
        } else {
          this.form_cadastro.controls['loja_selecionada'].setValue('');
        }


        
      }
    });

    this.form_cadastro.get('loja_selecionada').markAsTouched();
    //load.dismiss();
    await modal.present();
  }
  async carregarEmpresas() {
    await this.empresaProvider
      .get('')
      .then((response: any) => {
        if (response.Item) {
          this.malls = response.Item.map((item) => {
            return {
              ...item,
              title: item.nomEmpresa,
              value: item.idEmpresa,
            };
          });

          const shoppingSelecionado = this.malls.find(
            (x) => x.idEmpresa == this.configUser.shoppingCod
          );

          if (shoppingSelecionado && shoppingSelecionado != 'TODS') {
            this.form_cadastro.controls['shopping_selecionado'].setValue(
              shoppingSelecionado
            );
          }
        } else {
          this.globalService.publishToast({
            Mensagem: response.erro,
            Severidade: 2,
            Posicao: 'top',
          });
        }
      })
      .catch((error: any) => {
        this.globalService.publishToast({
          Mensagem: error.erro,
          Severidade: 2,
          Posicao: 'top',
        });
      });
  }

  downloadModeloPessoas() {
    const element = document.createElement('a');

    element.setAttribute('href', 'assets/docs/MODELO_IMPORTACAO_PESSOAS.xlsx');
    element.setAttribute('download', '');
    element.setAttribute('target', '_blank');

    element.click();
  }

  onPickModeloFile() {
    this.inputFileModelo.nativeElement.click();
  }

  async importarModeloPessoas(ev) {
    const file = this.inputFileModelo.nativeElement.files[0];
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = xlsxRead(data, { type: 'array' });

      const firstSheetName = workbook.SheetNames[1]; // Pessoas A Autorizar
      const worksheet = workbook.Sheets[firstSheetName];

      const jsonData = xlsxUtils.sheet_to_json(worksheet);

      if (Array.isArray(jsonData)) {
        const colaboradoresAdicionados = {};
        jsonData.forEach((item) => {
          // console.log("ItemColaborador", item)
          var formattedCPF = String(item['CPF']).replace(/\D/g, '');

          if(colaboradoresAdicionados[formattedCPF])
          {
            return;
          }
          
          colaboradoresAdicionados[formattedCPF] = true;

          this.addColaborador(item['NOME COMPLETO'], formattedCPF, item['NOME DA EMPRESA']);
        });
      }

      this.globalService.devlog('JSONMODELOS', jsonData, workbook);
    };

    reader.readAsArrayBuffer(file);
  }

  isFirstLoadServicos = true;
  async carregarServicos(idEmpresa) {
    this.servicosProvider
      .get({
        idEmpresa: idEmpresa,
      })
      .then((response) => {
        if (response.erro) {
          this.globalService.publishToast({
            Mensagem: response.erro,
            Severidade: 2,
            Posicao: 'top',
          });
        } else {
          if (response.Item && response.Item.length == 0) {
            return (this.servicos = []);
          }

          this.servicos = response.Item.map((item) => {
            return {
              ...item,
              title: item.nomeServico,
              value: item.idServico,
            };
          });
        }
      })
      .catch((err) => {
        this.globalService.publishToast({
          Mensagem: err.erro,
          Severidade: 2,
          Posicao: 'top',
        });
      }).finally(() => {
        if (this.isFirstLoadServicos) {
          this.isFirstLoadServicos = false;

          if (this.isEdit) {
            this.form_cadastro.controls['servico_selecionado'].setValue(
              this.autorizacaoServicoResponse.idServico
            );

            this.form_cadastro.markAllAsTouched();
          }
        }
      });
  }

  isFirstLoadEmpresa = true;
  async selecionarEmpresa(e: any) {
    let idEmpresa = e.detail?.value;
    if (!idEmpresa) return;

    this.stores = [];
    this.selected_contratoTexto = '';
    this.form_cadastro.controls['loja_selecionada'].setValue('');
    this.form_cadastro.controls['servico_selecionado'].setValue('');

    let loading = await this.loadingController.create({
      message: 'Aguarde...',
    });
    loading.present();

    if (idEmpresa && idEmpresa.idEmpresa) {
      idEmpresa = idEmpresa.idEmpresa;
    }

    await this.contratoProvider
      .get(idEmpresa, '', false)
      .then((response: any) => {
        loading.dismiss();
        if (response.Item) {
          this.stores = response.Item.map((item) => {
            return {
              ...item,
              title: `${item.nomContrato} (${item.lucLoja} - ${item.numContrato})`,
              value: item.numContrato,
            };
          });

          if (
            this.stores.length > 0 &&
            idEmpresa == this.configUser.shoppingCod
          ) {
            const globalSelectedStore = this.stores.find(
              (store) => store.numContrato == this.configUser.numContrato
            );

            if (globalSelectedStore) {
              this.selected_contratoTexto = globalSelectedStore.title;
              this.form_cadastro.controls['loja_selecionada'].setValue(
                globalSelectedStore.numContrato
              );
            }
          }
        } else {
          this.globalService.publishToast({
            Mensagem: response.erro,
            Severidade: 2,
            Posicao: 'top',
          });
        }
      })
      .catch((error: any) => {
        this.globalService.publishToast({
          Mensagem: error.erro,
          Severidade: 2,
          Posicao: 'top',
        });
        loading.dismiss();
      })
      .finally(() => {
        if (this.isFirstLoadEmpresa) {
          this.isFirstLoadEmpresa = false;

          if (this.isEdit) {
            this.selected_contratoTexto = this.autorizacaoServicoResponse.contrato?.nomContrato ? this.autorizacaoServicoResponse.contrato.nomContrato : "";

            this.form_cadastro.patchValue({
              loja_selecionada: this.autorizacaoServicoResponse.numContrato,
            });

            this.form_cadastro.markAllAsTouched();
          }
        }
        
        this.carregarServicos(idEmpresa);
      });
  }

  carregaServicoSelecionado(e: any) {
    let servico = e.detail?.value;
    if (!servico) return;
    servico = this.servicos.find((x) => x.idServico == servico);
    if (!servico) return;

    this.bdServicoData = servico;

    this.tituloServico = servico.nomeServico;

    const dtDiaPossivel = this.dataPossivelInicio;

    this.currentDate = dtDiaPossivel.toISOString();

    this.observacaoServico = [`A execução deste serviço deverá ocorrer entre ${
      servico.horaInicio
    } e as ${servico.horaFim} horas, a partir do dia ${format(
      dtDiaPossivel,
      'dd/MM',
      { locale: ptBR }
    )}, com uma duração máxima de ${servico.qtdDiasDuracaoMaxima} dia(s).`];

    if (servico.obrigatoriedadesOrientacoes) {
      this.observacaoServico.push(servico.obrigatoriedadesOrientacoes);
    }

    if (servico.mensagemParaLojista) {
      this.observacaoServico.push(servico.mensagemParaLojista);
    }
    
    if (!this.isEdit && servico.servicoArquivos) {
      const _toFiles: File[] = servico.servicoArquivos.map((item, index) => {
        return {
          idGestorDocumentos: item.idArquivoNavigation?.idGestorDocumentos,
          name: item.idArquivoNavigation?.nomeArquivo || `Arquivo ${index}`,
          ...item,
        };
      });

      this.pickedDocuments = _toFiles;
    }
  }

  mascaraTelefone(v) {
    var r = v.replace(/\D/g, '');
    r = r.replace(/^0/, '');

    if (r.length > 12) {
      r = r.replace(/^(\d\d)(\d{2})(\d{5})(\d{4}).*/, '($1) $2 $3-$4');
    }
    if (r.length > 10) {
      r = r.replace(/^(\d\d)(\d{1})(\d{4})(\d{4}).*/, '($1) $2 $3-$4');
    } else if (r.length > 9) {
      r = r.replace(/^(\d\d)(\d{4})(\d{4}).*/, '($1) $2-$3');
    }

    // } else if (r.length > 5) {
    //   r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, '($1) $2-$3');
    // } else if (r.length > 2) {
    //   r = r.replace(/^(\d\d)(\d{0,5})/, '($1) $2');
    // } else {
    //   r = r.replace(/^(\d*)/, '($1');
    // }
    return r;
  }

  onPickFile() {
    if (this.pickedDocuments.length === 5) {
      alert('Limite de arquivos atingido');
      return;
    }

    this.inputFile.nativeElement.click();
  }

  async addFile($event) {
    const file = this.inputFile.nativeElement.files[0];

    if (file.size > 10000000) {
      alert('Arquivo muito grande');
      return;
    }

    this.pickedDocuments = this.pickedDocuments.concat(file);
  }

  async removeFile(index: number) {
    this.pickedDocuments.splice(index, 1);
  }

  validaDataServico(): boolean {
    let isValid = true;

    const _servico = this.servicos.find(
      (x) => x.idServico == this.form_cadastro.get('servico_selecionado').value
    );

    const _dataInicio = this.form_cadastro.get('dataInicio').value
      ? new Date(this.form_cadastro.get('dataInicio').value + ' 00:00:00')
      : null;

    const _dataFim = this.form_cadastro.get('dataTermino').value
      ? new Date(this.form_cadastro.get('dataTermino').value + ' 00:00:00')
      : null;

    if (!_dataInicio || !_dataFim) {
      if (!_dataFim) {
        this.form_cadastro.get('dataTermino').setErrors({
          invalid: true,
        });
      } else {
        this.form_cadastro.get('dataInicio').setErrors({
          invalid: true,
        });
      }

      isValid = false;
    }

    const duracaoMaxima = _servico.qtdDiasDuracaoMaxima;

    if (
      typeof duracaoMaxima == 'number' &&
      duracaoMaxima > 0 &&
      _dataFim &&
      _dataInicio
    ) {
      //console.log(_dataInicio, _dataFim, isAfter(_dataInicio, _dataFim), isAfter(_dataFim, _dataInicio))
      if(_dataFim < _dataInicio)
      {
        this.form_cadastro.get('dataTermino').setErrors({
          min: true,
        });

        this.form_cadastro.get('dataTermino').markAsTouched();

        isValid = false;
        return isValid;
      }
      const eachDays = eachDayOfInterval({ start: _dataInicio, end: _dataFim });

      //Remove a data de início da lista;
      eachDays.shift();

      if (eachDays.length > duracaoMaxima) {
        this.form_cadastro.get('dataTermino').setErrors({
          max: true,
        });

        this.form_cadastro.get('dataTermino').markAsTouched();

        // this.form_cadastro.get('dataInicio').setErrors({
        //   servicomax: true,
        // });

        isValid = false;
      }
    }

    return isValid;
  }

  async getDados() {
    const postFiles = [];

    for await (const file of this.pickedDocuments) {
      try {
        if (file.isEditAutorizationFile) continue;

        if (file.idGestorDocumentos) {
          postFiles.push({
            ...file,
            fileName: file.name
          });
        } else {
          const base64 = await DevUtils.fileToBase64(file);

          postFiles.push({
            base64,
            fileName: file.name,
          });
        }
      } catch (error) {
        //console.log(error);
      }
    }

    const _dataInicio = this.form_cadastro.get('dataInicio').value;

    const _dataFim = this.form_cadastro.get('dataTermino').value;

    const _horaInicio = this.form_cadastro.get('timeInicio').value;

    const _horaFim = this.form_cadastro.get('timeTermino').value;

    const _servico = this.servicos.find(
      (x) => x.idServico == this.form_cadastro.get('servico_selecionado').value
    );

    return {
      ...(this.autorizacaoServicoId && { IdAutorizacaoServico: this.autorizacaoServicoId }),
      descricao: this.form_cadastro.get('descricaoServico').value,
      dataInicio: _dataInicio,
      dataFim: _dataFim,
      horaInicio: _horaInicio,
      horaFim: _horaFim,
      telefoneContato: this.form_cadastro
        .get('telefoneContato')
        .value.replace(/\D/g, ''),
      observacaoParaAprovador: this.form_cadastro.get(
        'observacaoParaOAprovador'
      ).value,
      protocolo: this.isEdit ? this.autorizacaoServico.protocolo : this.form_cadastro.get('shopping_selecionado').value + new Date().getUTCFullYear(),
      nomeServico: _servico?.nomeServico,
      idServico: _servico?.idServico,
      idStatusAutorizacaoServico: this.isEdit ? this.autorizacaoServico.idStatusAutorizacaoServico : 1,
      idEmpresa: this.form_cadastro.get('shopping_selecionado').value,
      numContrato: this.form_cadastro.get('loja_selecionada').value != '' ? this.form_cadastro.get('loja_selecionada').value : null,
      dataInclusao: new Date(),
      AutorizacaoServicoCarros: [
        ...this.veiculos.value.map((veiculo) => {
          return {
            Marca: veiculo.marca,
            Modelo: veiculo.modelo,
            Cor: veiculo.cor,
            Placa: veiculo.placa,
          };
        }),
      ],
      AutorizacaoServicoColaboradors: [
        ...this.colaboradores.value.map(colaborador => {
          return {
            CpfColaborador: colaborador.cpf,
            NomeColaborador: colaborador.nome,
            NomeEmpresaColaborador: colaborador.empresa,
          };
        }),
      ],
      AutorizacaoServicoDepartamentos: [],
      ComentarioAutorizacaoServicos: [],
      Arquivos: postFiles,
    };
  }

  async onEnviar(avisoHorarioExcedente = null, avisoColaboradores = false) {
    if (!this.form_cadastro.valid) {
      this.globalService.devlog('Createautorizacao', 'form invalido', this.form_cadastro);
      this.validateAllFormFields(this.form_cadastro);
      this.validateAllFormFieldsVeiculosArray(this.veiculos);
      this.seekToErrorElement(this.form_cadastro);

      return;
    }

    if (this.bdServicoData?.obrigarAnexoLojista == true && this.pickedDocuments.length == 0) {
      this.globalService.presentToast('É necessário anexar um documento para este serviço!', ToastColors.danger);
      return;
    }

    this.clearColaboradores();
    if (this.colaboradores.value.length === 0 && avisoColaboradores === false) {
      this.globalService.showAviso('Nenhum colaborador foi cadastrado. Deseja realmente enviar a autorização de serviço?', onConfirm => {
        if (onConfirm) {
          this.onEnviar(null, true);
        }
      })

      return;
    }

    this.globalService.devlog(this.form_cadastro, this.colaboradores.value, this.veiculos.value);

    const isValidStartEndDate = this.validaDataServico();
    if (isValidStartEndDate == false) {
      return;
    }

    const loading = await this.loadingController.create({
      message: 'Aguarde...',
    });

    loading.present();

    const dados = await this.getDados();


    if (dados && dados.AutorizacaoServicoColaboradors && dados.AutorizacaoServicoColaboradors.length > 0) {
      dados.AutorizacaoServicoColaboradors.forEach((colaborador: any) => {
        if (colaborador.CpfColaborador) {
          colaborador.CpfColaborador = colaborador.CpfColaborador.toString().replace(/\D/g, '').substring(0, 11);
        }
      });
    }

    this.autorizacaoServicoProvider
      .addUpdateAutorizacaoServico(dados)
      .then((response) => {
        this.globalService.devlog('Createautorizacao', 'response', response);

        if (response.Item) {
          const isAgendada = !!response.Item.autorizacaoDeServicoJson;
          if (response.erro) {
            this.globalService.presentToast(
              `Autorização ${ this.isEdit ? 'ajustada' : isAgendada ? 'agendada' : 'criada' } com exceções: ${response.erro}`,
              ToastColors.danger
            );
          } else {
            if (this.isEdit) {
              this.globalService.presentToast(
                "Autorização ajustada com sucesso. Clique em ENVIAR para encaminhar para aprovação novamente.",
                ToastColors.success
              );
            } else {
              this.globalService.presentToast(
                `Autorização ${ isAgendada ? 'agendada' : 'criada' } com sucesso! Protocolo: ${response.Item.protocolo}`,
                ToastColors.success
              );
            }
          }

          let responseDismiss = {}

          responseDismiss['editado'] = this.isEdit ? true : false;
          responseDismiss['criado'] = this.isEdit ? false : true;
          this.dismiss(responseDismiss);
        }
      })
      .catch((error) => {
        this.globalService.devlog('Createautorizacao', 'error', error);
        this.globalService.presentToast(
          'Não foi possível conectar se ao BPM. Tente novamente mais tarde.',
          ToastColors.danger
        )
      })
      .finally(() => {
        loading.dismiss();
      });
  }

  dismiss(data = {}) {
    this.event.publish('authorization.getAutorizacoes', {});
    this.modalCtrl.dismiss(data);
  }

  validateAllFormFields(formGroup: FormGroup) {
    //{1}
    Object.keys(formGroup.controls).forEach((field) => {
      //{2}
      const control = formGroup.get(field); //{3}
      if (control instanceof FormControl) {
        //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        //{5}
        this.validateAllFormFields(control); //{6}
      } else if(control instanceof FormArray){
        control.controls.forEach(element => {
          if (element instanceof FormControl)
            element.markAsTouched({ onlySelf: true });
          else
            this.validateAllFormFields(element as FormGroup)
        });
      }
    });
  }

  validateAllFormFieldsArray(formGroupArray: FormArray) {
    formGroupArray.controls.forEach(element => {
      if (element instanceof FormControl) {
        element.markAsTouched({ onlySelf: true });
      } else {
        this.validateAllFormFields(element as FormGroup)
      }
    });
  }

  hasDuplicate(key_form: string, duplicates: any[]): ValidatorFn {
    return (formArray: FormArray): ValidationErrors | null => {
      if (duplicates as []) {
        for (var i = 0; i < duplicates.length; i++) {
          let errors = formArray.at(duplicates[i])?.get(key_form).errors as Object || {};
          delete errors['duplicated'];
          if(!Object.values(errors).length)
            errors = null;

          formArray.at(duplicates[i])?.get(key_form).setErrors(errors as ValidationErrors);
        }
      }

      let dict = {};
      formArray.value.forEach((item, index) => {
        dict[item[key_form]] = dict[item[key_form]] || [];
        dict[item[key_form]].push(index);
      });

      duplicates = [];
      for (var key in dict) {
        if (dict[key].length > 1)
          duplicates = duplicates.concat(dict[key]);
      }

      for (const index of duplicates) {
        formArray.at(+index).get(key_form).setErrors({ duplicated: true });
      }

      return duplicates.length > 0 ? { duplicated: true } : null;
    };
  }

  async previewFile(file) {
    console.log(file)

    const loading = await this.loadingController.create({
      message: 'Carregando...',
    });

    loading.present();

    this.servicosProvider.getFilesByIds([file.idArquivo], file.idServico).then((res) => {
      if (Array.isArray(res.rows) && res.rows.length > 0) {
        const file = res.rows[0];

        if (this.isMobile) {
          const url = file.urlDownload;
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', file.nome);
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          const url = file.urlVisualizacao;
          window.open(url, '_blank');
        }
      } else {
        this.globalService.devconsole('Arquivo não encontrado', res);

        this.globalService.presentToast(
          'Arquivo não encontrado para visualização',
          ToastColors.tertiary
        );
      }
    }).finally(() => {
      loading.dismiss();
    });
  }

  /* --- Colaboradores --- */
  addColaborador(nome = '', cpf = '', empresa = '', idAutorizacaoServico = null) {
    if (!this.colaboradores.valid) {
      this.validateAllFormFieldsArray(this.colaboradores);
      this.seekToErrorElement(this.colaboradores);

      return;
    }

    this.colaboradores.push(
      this.formBuilder.group({
        nome: new FormControl(nome, Validators.compose([
          Validators.required,
          Validators.maxLength(100)
        ])),
        cpf: new FormControl(cpf, Validators.compose([
          this.validateCPFColaborador(),
          Validators.required,
        ])),
        empresa: new FormControl(empresa, Validators.compose([
          Validators.required,
          Validators.maxLength(100)
        ])),
        idAutorizacaoServico: new FormControl(idAutorizacaoServico),
      })
    );
  }

  async delColaborador(index, colaborador) {
    if (colaborador.value?.idAutorizacaoServico) {
      const alert = await this.alertController.create({
        header: 'Confirmar Ação',
        message: 'Deseja mesmo excluir este colaborador? (Esta ação é irreversível)',
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
            handler: () => { },
          },
          {
            text: 'Confirmar',
            role: 'confirm',
            handler: () => {
              this.excluirColaborador(index, colaborador.value?.idAutorizacaoServico, colaborador.value?.cpf);
            },
          },
        ],
      });
  
      await alert.present();
    } else {
      this.colaboradores.removeAt(index);
      this.colaboradores.updateValueAndValidity();
    }
  }

  async excluirColaborador(index, idAutorizacaoServico, idColaborador) {
    const loading = await this.loadingController.create({
      message: 'Aguarde...',
    });

    loading.present();

    await this.autorizacaoServicoProvider.deleteColaborador(idAutorizacaoServico, idColaborador).then((response) => {
      if (response.Item) {
        this.globalService.presentToast(
          'Colaborador excluído com sucesso!',
          ToastColors.success
        );

        this.colaboradores.removeAt(index);
        this.colaboradores.updateValueAndValidity();
      } else {
        this.globalService.presentToast(
          'Não foi possível deletar o colaborador. Tente novamente mais tarde.',
          ToastColors.danger
        );
      }
    }).catch((error) => {
      this.globalService.presentToast(
        'Não foi possível deletar o colaborador. Tente novamente mais tarde.',
        ToastColors.danger
      );
    }).finally(() => {
      loading.dismiss();
    });
  }

  validateCPFColaborador(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const cpf = control.value as string;

      if(!APIService.ValidaCPF(cpf)){
        return { format: true }
      }

      return null;
    };
  }

  clearColaboradores(){
    const formGroups = this.colaboradores;

    for (let i = formGroups.length - 1; i >= 0; i--) {
      const colaborador = formGroups.at(i) as FormGroup;
      const controls = colaborador.controls;
      let isEmpty = Object.values(controls).every(control => !control.value);

      if (isEmpty) {
        formGroups.removeAt(i);
      }
    }
  }
  /* --- --- */

  /* --- Veículos --- */
  validateAllFormFieldsVeiculosArray(formGroupArray: FormArray) {
    formGroupArray.controls.forEach(element => {
      if (element.errors?.marcaOuModeloObrigatorio) {
        element.get('marca').setErrors({ manualError: true });
        element.get('modelo').setErrors({ manualError: true });
      } else {
        element.get('marca').setErrors(null);
        element.get('modelo').setErrors(null);
      }

      if (element instanceof FormControl) {
        element.markAsTouched({ onlySelf: true });
      } else {
        this.validateAllFormFields(element as FormGroup)
      }
    });
  }

  marcaOuModeloValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const marca = control.get('marca');
      const modelo = control.get('modelo');

      if ((marca && marca.value != "") || (modelo && modelo.value != "")) {
        return null;
      } else {
        return { marcaOuModeloObrigatorio: true };
      }
    };
  }

  addVeiculo(marca = '', modelo = '', cor = '', placa = '', idAutorizacaoServico = null) {
    if (!this.veiculos.valid) {
      this.validateAllFormFieldsVeiculosArray(this.veiculos);
      this.seekToErrorElement(this.veiculos);

      return;
    }

    this.veiculos.push(
      this.formBuilder.group({
        marca: new FormControl(marca),
        modelo: new FormControl(modelo),
        cor: new FormControl(cor),
        placa: new FormControl(placa, Validators.compose([
          Validators.required,
        ])),
        idAutorizacaoServico: new FormControl(idAutorizacaoServico),
      }, { validators: this.marcaOuModeloValidator() })
    );
  }

  async delVeiculo(index, veiculo) {
    if (veiculo.value?.idAutorizacaoServico) {
      const alert = await this.alertController.create({
      header: 'Confirmar Ação',
      message: 'Deseja mesmo excluir este veículo? (Esta ação é irreversível)',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => { },
        },
        {
          text: 'Confirmar',
          role: 'confirm',
          handler: () => {
            this.excluirVeiculo(index, veiculo.value?.idAutorizacaoServico, veiculo.value?.placa);
          },
        },
      ],
    });

    await alert.present();
    } else {
      this.veiculos.removeAt(index);
      this.veiculos.updateValueAndValidity();
    }
  }

  async excluirVeiculo(index, idAutorizacaoServico, idVeiculo) {
    const loading = await this.loadingController.create({
      message: 'Aguarde...',
    });

    loading.present();

    await this.autorizacaoServicoProvider.deleteVeiculo(idAutorizacaoServico, idVeiculo).then((response) => {
      if (response.Item) {
        this.globalService.presentToast(
          'Veículo excluído com sucesso!',
          ToastColors.success
        );

        this.veiculos.removeAt(index);
        this.veiculos.updateValueAndValidity();
      } else {
        this.globalService.presentToast(
          'Não foi possível deletar o veículo. Tente novamente mais tarde.',
          ToastColors.danger
        );
      }
    }).catch((error) => {
      this.globalService.presentToast(
        'Não foi possível deletar o veículo. Tente novamente mais tarde.',
        ToastColors.danger
      );
    }).finally(() => {
      loading.dismiss();
    });
  }

  clearVeiculos(){
    const formGroups = this.veiculos;

    for (let i = formGroups.length - 1; i >= 0; i--) {
      const colaborador = formGroups.at(i) as FormGroup;
      const controls = colaborador.controls;
      let isEmpty = Object.values(controls).every(control => !control.value);

      if (isEmpty) {
        formGroups.removeAt(i);
      }
    }
  }

  limpaErrosMarcaOuModeloValidator(control, field: string) {
    control.get(field).setErrors(null)
    control.markAsTouched({ onlySelf: true });
  }

  mascaraCPF(event: any, indexFormControl: number) {
    // 1. Pega o valor diretamente do evento disparado
    const valorDigitado = event.detail.value;
    
    if (!valorDigitado) return;

    // 2. Limpa tudo que não for número
    let valorLimpo = valorDigitado.toString().replace(/\D/g, '');

    // 3. Limita a 11 números máximos
    if (valorLimpo.length > 11) {
      valorLimpo = valorLimpo.substring(0, 11);
    }

    // 4. Força a alteração no componente visual na mesma hora (evita o caractere piscar na tela)
    event.target.value = valorLimpo;

    // 5. Sincroniza com o Reactive Forms sem disparar um loop
    const control = this.colaboradores.at(indexFormControl).get('cpf');
    if (control && control.value !== valorLimpo) {
      control.setValue(valorLimpo, { emitEvent: false });
    }
  }

  /* --- --- */
}


